module.exports = __webpack_public_path__ + "static/media/2_04.5dfa6453.png";